import { useGlobalStore } from '../../../application/store/store.tsx';
import { axiosInstance } from '../../../common/axiosInstans.ts';
import { UserRole } from '../../../application/types/userRole.ts';
import {
    Organization,
    UserOrganization,
} from '../../superAdmin/TenantOrganizations/OrganizationService.ts';

export interface Profile {
    id: string;
    userName: string;
    firstName: string;
    lastName: string;
    email: string;
    isActive: boolean;
    emailConfirmed: boolean;
    phoneNumber: string;
    imageUrl: string;
    requirePasswordChange: boolean;
    tenantConfig: {
        allowedTransactionRegistrations: number;
        formRegistrationMethod: 'manual' | 'barcode';
    };
    userRoles: UserRole[];
    selectedOrganization: Organization;
    organizations: UserOrganization[];
}

export class ProfileService {
    getProfile = async (): Promise<Profile> => {
        try {
            const response = await axiosInstance.get('/personal/profile');
            useGlobalStore.getState().setProfile(response.data);
            return response.data;
        } catch (ex) {
            throw ex;
        }
    };

    async updateProfile(firstName, lastName) {
        const getProfile = await this.getProfile();
        if (firstName == null || firstName == '') {
            return { success: false, error: 'Något gick fel!' };
        }
        try {
            let response = await axiosInstance.put('/personal/profile', {
                id: getProfile.id,
                firstName: firstName,
                lastName: lastName,
            });
            return { success: true, data: response.data };
        } catch (ex) {
            return { success: false, error: 'Något gick fel!' };
        }
    }

    async updatePassword(password, newPassword, confirmNewPassword) {
        try {
            const response = await axiosInstance.put(
                '/personal/change-password',
                {
                    password,
                    newPassword,
                    confirmNewPassword: confirmNewPassword,
                }
            );
            return { success: true, data: response.data };
        } catch (ex) {
            if (ex.status === 503) {
                return { success: false, error: 'Server är offline.' };
            }
            return {
                success: false,
                error:
                    'Något gick fel! ' +
                    'Lösenord behöver vara minst 6 tecken och innehålla en siffra, en liten bokstav och en stor bokstav',
            };
        }
    }

    async passwordResetRequest(tenant: string, email: string) {
        try {
            if (
                localStorage.getItem('orgId') === null ||
                localStorage.getItem('orgId') === ''
            ) {
                return { success: false, error: 'No OrgId!' };
            }
            const response = await axiosInstance.post(
                '/users/forgot-password',
                {
                    email: email,
                    originUrl: window.location.origin,
                },
                {
                    headers: {
                        tenant: tenant,
                    },
                }
            );

            return { success: true, data: response };
        } catch (ex) {
            return { success: false, error: ex };
        }
    }

    async resetPassword(
        email: string,
        password: string,
        token: string,
        tenant: string
    ) {
        try {
            const response = await axiosInstance.post(
                '/users/reset-password',
                {
                    email: email,
                    password: password,
                    token: token,
                },
                {
                    headers: {
                        tenant: tenant,
                    },
                }
            );
            return { success: true, data: response };
        } catch (ex) {
            return { success: false, error: ex };
        }
    }
}
